import React from 'react';
import PropTypes from 'prop-types';
import Rating from '../../../../products/components/rating/Rating';
import styles from './ReviewsHeader.module.sass';

function ProductHeader(props) {
  const {
    rating = 0, reviewsCount = 0, customColor,
  } = props;
  return (
    <div className={styles['reviews-header']}>
      <h4>Reviews</h4>
      { reviewsCount > 0 && (
      <div className={styles['header-content']}>
        { rating > 0 && (
          <>
            <span className={styles['rating-number']} style={{ color: customColor }}>
              {rating}
            </span>
            <Rating rating={rating} className={styles['review-header-stars']} color={customColor} />
          </>
        )}
        <div className={styles['reviews-count']}>
          {`${reviewsCount.toLocaleString('en-US')} Reviews`}
        </div>
      </div>
      )}
    </div>
  );
}

ProductHeader.propTypes = {
  rating: PropTypes.number,
  reviewsCount: PropTypes.number,
  customColor: PropTypes.string.isRequired,
};

export default ProductHeader;
